module.exports = __webpack_public_path__ + "img/koedboller_fars.16eb9dae.jpg";